import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { reportError } from '@/app/utils/functions'
import { useLiffToken } from '@/app/store'
import axios from 'axios'

type StationStore = {
    data: any | null
    questionTriggerRate: number | null
    getData: () => void
    setQuestionTriggerRate: (rate: number | null) => void
}
const useStation = create<StationStore>()(
    persist(
        (set) => ({
            data: null as StationStore["data"],
            questionTriggerRate: null as StationStore["questionTriggerRate"],
            getData: () => {
                axios.get('/api/stations/all')
                .then((res) => {
                    // console.log(res.config.url, res.data)
                    set({ data: res.data })
                })
                .catch((err) => {
                    // console.log(err.config?.url, err)
                    reportError(err, true)
                    set({ data: false })
                })
            },
            setQuestionTriggerRate: (rate) => {
                set({ questionTriggerRate: rate })
            }
        }),
        {
            name: 'station',
            partialize: (state) => ({
                data: state.data
            }),
        }
    )
)
const unsub = useLiffToken.subscribe((state) => {
    if (state.token) {
        useStation.getState().getData()
        unsub()
    }
})

export default useStation
